let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dLC2d")).then(() => parcelRequire('7RAEq'));